import { Loader } from 'ypf-pas-general-ui-components';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { workReportLineStatus } from '../../../../utils/dataStatus';
import { setInputBackgroundColor } from '../../../../utils/workReportLinesUtils';
import { checkRol } from '../../../../security';
import { inspector } from '../../../../security/constantsRols';
import { Line } from '../../../../utils/globalPropTypes';
import ProgramPointIterableList from '../LocationProgramPointList/LocationProgramPointList';

import ProgramPointFooter from './ProgramPointFooter';
import ProgramPointTitle from './ProgramPointTitle';
import ProgramPointTableHeader from './ProgramPointTableHeader';
import ProgramPointRow from './ProgramPointRow';

const ProgramPointList = ({
  dailyView,
  disabledButton,
  disabledInputPP,
  disabledInputQuantity,
  displayButtons,
  displayFixedlabel,
  editCSA,
  handleClickRectifyButton,
  idParteDiario,
  line,
  loading,
  onChangeExpertReview,
  quantityTotalReturn,
  selectedDate,
  setFieldValue,
  showAlert,
  showExpertReview,
  showRectifyQuantityButton,
  showTitle,
  tipoAsignacion,
  values,
  eventoSigla,
  viewCSA,
  viewInputs,
  isExtentedView,
  showWarningOperationalData,
  isLocation = false
}) => {
  const isInspector = checkRol(inspector);
  const isFixedOrReturnedAndHasPP =
    line?.estadoEnum === workReportLineStatus.fijar ||
    line?.estadoEnum === workReportLineStatus.devolver
      ? line?.tienePuntosPrograma
      : false;

  return (
    <>
      {showTitle && <ProgramPointTitle line={line} selectedDate={selectedDate} />}
      <hr className="divide-line mt-4 " />
      {showAlert && (
        <Alert bsPrefix="fade alert alert-color" variant="warning">
          <span className="alert-color-text">Falta completar datos operativos.</span>
        </Alert>
      )}
      {showWarningOperationalData && (
        <Alert bsPrefix="fade alert alert-color" variant="warning">
          <span className="alert-color-text">
            Se envía a aprobar la cantidad de todas las líneas, pero el detalle operativo sólo de la
            primera.
          </span>
        </Alert>
      )}

      {loading && <Loader show={loading} text="Cargando" />}
      {isLocation ? (
        <ProgramPointIterableList
          {...{
            line,
            dailyView,
            displayButtons,
            viewCSA,
            isExtentedView,
            disabledButton,
            disabledInputPP,
            disabledInputQuantity,
            editCSA,
            idParteDiario,
            setFieldValue,
            tipoAsignacion,
            handleClickRectifyButton,
            isInspector,
            onChangeExpertReview,
            setInputBackgroundColor,
            showExpertReview,
            showRectifyQuantityButton,
            expertReview: values?.expertReview,
            eventoSigla,
            viewInputs,
            values
          }}
        />
      ) : (
        <div className="d-flex flex-column" style={{ height: '200px' }}>
          <div className="mb-1">
            <ProgramPointTableHeader
              {...{ line, dailyView, displayButtons, viewCSA, isExtentedView }}
            />
          </div>
          <div className="infinte-scroll">
            {values?.programPoints?.map((programPoint, index) => (
              <ProgramPointRow
                key={`programPoint-${programPoint?.id}-${line?.idParteDiario}-${index?.toString()}`}
                {...{
                  dailyView,
                  disabledButton,
                  disabledInputPP,
                  disabledInputQuantity,
                  displayButtons,
                  editCSA,
                  idParteDiario,
                  setFieldValue,
                  tipoAsignacion,
                  handleClickRectifyButton,
                  index,
                  isInspector,
                  line,
                  onChangeExpertReview,
                  programPoint,
                  setInputBackgroundColor,
                  showExpertReview,
                  showRectifyQuantityButton,
                  expertReview: values?.expertReview,
                  viewCSA,
                  eventoSigla,
                  viewInputs,
                  values,
                  isExtentedView
                }}
              />
            ))}
          </div>
        </div>
      )}
      <ProgramPointFooter
        displayFixedlabel={displayFixedlabel}
        isFixedOrReturnedAndHasPP={isFixedOrReturnedAndHasPP}
        line={line}
        quantityTotalReturn={values?.locationTotalValueFijado || quantityTotalReturn}
        totalValue={values?.locationTotalValue || values?.totalValue || 0}
      />
    </>
  );
};

export default ProgramPointList;

ProgramPointList.propTypes = {
  line: Line,
  values: PropTypes.shape({
    programPoints: PropTypes.arrayOf(PropTypes.shape({})),
    locationTotalValueFijado: PropTypes.number,
    totalValue: PropTypes.number,
    locationTotalValue: PropTypes.number,
    expertReview: PropTypes.bool
  }),
  disabledButton: PropTypes.bool,
  selectedDate: PropTypes.string,
  loading: PropTypes.bool,
  disabledInputQuantity: PropTypes.bool,
  disabledInputPP: PropTypes.bool,
  quantityTotalReturn: PropTypes.string,
  dailyView: PropTypes.bool,
  displayFixedlabel: PropTypes.bool,
  setFieldValue: PropTypes.func,
  displayButtons: PropTypes.bool,
  showRectifyQuantityButton: PropTypes.bool,
  handleClickRectifyButton: PropTypes.func,
  onChangeExpertReview: PropTypes.func,
  showTitle: PropTypes.bool,
  viewCSA: PropTypes.bool,
  editCSA: PropTypes.bool,
  showAlert: PropTypes.bool,
  tipoAsignacion: PropTypes.number.isRequired,
  idParteDiario: PropTypes.number.isRequired,
  showExpertReview: PropTypes.bool,
  viewInputs: PropTypes.bool,
  isExtentedView: PropTypes.bool,
  showWarningOperationalData: PropTypes.bool,
  eventoSigla: PropTypes.string,
  isLocation: PropTypes.bool
};
ProgramPointList.defaultProps = {
  line: {
    positionName: '',
    lineName: '',
    idParteDiario: 0,
    estadoEnum: 0,
    tienePuntosPrograma: false
  },
  values: {
    programPoints: [],
    totalValue: 0,
    locationTotalValue: 0,
    locationTotalValueFijado: 0
  },
  disabledButton: false,
  disabledInputQuantity: false,
  disabledInputPP: false,
  selectedDate: new Date().toISOString().split('T')[0],
  loading: false,
  quantityTotalReturn: 0,
  dailyView: false,
  displayFixedlabel: false,
  setFieldValue: () => {},
  onChangeExpertReview: () => {},
  displayButtons: false,
  showRectifyQuantityButton: false,
  handleClickRectifyButton: () => {},
  showTitle: false,
  viewCSA: false,
  editCSA: false,
  showAlert: false,
  showExpertReview: false,
  viewInputs: false,
  isExtentedView: false,
  showWarningOperationalData: false,
  eventoSigla: '',
  isLocation: false
};
